var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobiledesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_300_807)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0.954285C10.8954 0.954285 10 1.80876 10 2.86281V35.3078C10 36.3619 10.8954 37.2163 12 37.2163H27.9C29.0046 37.2163 29.9 36.3619 29.9 35.3078V2.86281C29.9 1.80876 29.0046 0.954285 27.9 0.954285H24.6631V1.90855H15.2368V0.954285H12Z",
    fill: "url(#paint0_linear_300_807)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5084 34.0429C17.1349 34.0429 16.8321 34.3319 16.8321 34.6883C16.8321 35.0447 17.1349 35.3336 17.5084 35.3336V34.0429ZM22.4632 35.3336C22.8367 35.3336 23.1395 35.0447 23.1395 34.6883C23.1395 34.3319 22.8367 34.0429 22.4632 34.0429V35.3336ZM9.3999 28.0688C9.3999 28.4252 9.70271 28.7142 10.0762 28.7142C10.4498 28.7142 10.7526 28.4252 10.7526 28.0688H9.3999ZM10.7526 30.9058C10.7526 30.5492 10.4498 30.2603 10.0762 30.2603C9.70271 30.2603 9.3999 30.5492 9.3999 30.9058H10.7526ZM29.2191 7.26484C29.2191 7.62129 29.5219 7.91024 29.8954 7.91024C30.2689 7.91024 30.5717 7.62129 30.5717 7.26484H29.2191ZM30.5717 10.1017C30.5717 9.74533 30.2689 9.45634 29.8954 9.45634C29.5219 9.45634 29.2191 9.74533 29.2191 10.1017H30.5717ZM27.4799 36.8797H12.4917V38.1706H27.4799V36.8797ZM12.4917 1.2908H15.5265V0H12.4917V1.2908ZM14.8502 1.61467H16.2028V0.645396H14.8502V1.61467ZM16.4927 3.18206H23.479V1.89127H16.4927V3.18206ZM15.5265 1.2908H24.4451V0H15.5265V1.2908ZM24.4451 1.2908H27.4799V0H24.4451V1.2908ZM25.1215 1.61467V0.645396H23.7688V1.61467H25.1215ZM17.5084 35.3336H22.4632V34.0429H17.5084V35.3336ZM10.7526 28.0688V2.95038H9.3999V28.0688H10.7526ZM10.7526 35.2202V30.9058H9.3999V35.2202H10.7526ZM29.2191 2.95038V7.26484H30.5717V2.95038H29.2191ZM29.2191 10.1017V35.2202H30.5717V10.1017H29.2191ZM23.479 3.18206C24.3861 3.18206 25.1215 2.48032 25.1215 1.61467H23.7688C23.7688 1.76743 23.6391 1.89127 23.479 1.89127V3.18206ZM12.4917 36.8797C11.5312 36.8797 10.7526 36.1367 10.7526 35.2202H9.3999C9.3999 36.8496 10.7841 38.1706 12.4917 38.1706V36.8797ZM27.4799 38.1706C29.1875 38.1706 30.5717 36.8496 30.5717 35.2202H29.2191C29.2191 36.1367 28.4404 36.8797 27.4799 36.8797V38.1706ZM27.4799 1.2908C28.4404 1.2908 29.2191 2.03381 29.2191 2.95038H30.5717C30.5717 1.32093 29.1875 0 27.4799 0V1.2908ZM14.8502 1.61467C14.8502 2.48032 15.5855 3.18206 16.4927 3.18206V1.89127C16.3326 1.89127 16.2028 1.76743 16.2028 1.61467H14.8502ZM12.4917 0C10.7841 0 9.3999 1.32093 9.3999 2.95038H10.7526C10.7526 2.03381 11.5312 1.2908 12.4917 1.2908V0Z",
    fill: "url(#paint1_linear_300_807)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_300_807",
    x1: 11.1277,
    y1: 0.954285,
    x2: 39.0158,
    y2: 17.8542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.259336,
    stopColor: "#FFDB6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_300_807",
    x1: 10.5996,
    y1: 7.69839e-7,
    x2: 40.0994,
    y2: 18.0681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.259336,
    stopColor: "#FFDB6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC5E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_300_807"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 38.1706,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobiledesign);
export default __webpack_public_path__ + "static/media/mobiledesign.e7ae8fbc5fabab58004c08e05f84db45.svg";
export { ForwardRef as ReactComponent };